import React, { useState } from 'react'
import { useParams } from 'react-router-dom'
import { ADMIN_ROLE_SLUG, OPERATIVE_ROLE_SLUG } from '~/Constants'
import DairyQuery from '~/QueryHooks/DairyQuery'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import { useAuth } from '~/routes/components/AuthProvider'
import { El as LayoutEl } from '~/components/Layout/style';
import notify from '~/components/Notify'
import Dialog from '~/components/Dialog'
import { Popup } from 'semantic-ui-react'
import CustomIcon from '~/components/CustomIcon'
import CreateEditTransponderId from './CreateEditTransponderId'
import { useTranslation } from 'react-i18next'

const getTableColumns = (t) => [
  {
    name: t('Unique ID'),
    key: 'uniqueId'
  },
  {
    name: t('Status'),
    key: 'status',
    type: 'verification'
  },
  {
    name: t('Date From'),
    key: 'dateFrom',
    type: 'date',
    format: 'DD.MM.YYYY'
  },
  {
    name: t('Date To'),
    key: 'dateTo',
    type: 'date',
    format: 'DD.MM.YYYY'
  },
  {
    name: t('Actions')
  }
];

const TransponderId: React.FC = () => {
  const { t } = useTranslation()
  const { id: farmerId } = useParams<{ id: string }>()
  const { systemData: { logged: { roleSlug } } } = useAuth()
  const displayAction = roleSlug === ADMIN_ROLE_SLUG || roleSlug === OPERATIVE_ROLE_SLUG

  const [drawer, setDrawerState] = useState({
    isVisible: false,
    id: null
  })
  const [selectedItem, setSelectedItem] = useState(null)
  const actions = [
    {
      popupMessage: t('Edit'),
      type: 'icon',
      name: 'pencil',
      size: 'large',
      actionType: 'edit',
      displayedText: t('No actions')
    },
    {
      popupMessage: t('Delete'),
      type: 'icon',
      name: 'trash',
      size: 'large',
      actionType: 'delete',
      displayedText: t('No actions'),
      renderActions: getAction
    }
  ]

  function getAction(row, type) {
    return <Popup
      content={t('Delete')}
      trigger={<CustomIcon
        size='large'
        style={{ marginBottom: 2 }}
        onClick={() => setSelectedItem(row)}
        name='trash' />}
    />
  }

  const onSuccess = () => {
    notify(t('Successfully deleted transponder ID'), 'success');
    fetchData();
  };

  const {
    isLoading: isBusyData,
    data: transponderIds,
    refetch: fetchData
  } = DairyQuery.getTransponderIds(farmerId)

  const { isLoading: isDeleteLoading, mutate: deleteTransponderId } = DairyQuery.deleteTransponderId(
    onSuccess
  );

  async function onTransponderIdDelete() {
    deleteTransponderId({ farmerId, id: selectedItem?.id })
    setSelectedItem(null)
  }

  function handleActionClick(row, type) {
    switch (type) {
      case 'edit':
        return setDrawerState({ isVisible: true, id: row?.id })
      default:
        return
    }
  }

  function renderTable() {
    const { filtered, rows } = transponderIds ? transponderIds : { filtered: 0, rows: [] };
    return <TableComponent
      tableColumnHeaders={getTableColumns(t)}
      rows={rows || []}
      total={filtered || 0}
      handleClickAction={handleActionClick}
      removePagination
      actions={displayAction ? actions : []}
    />
  }

  function renderActions() {
    return <LayoutEl.PageHeaderActionButton
      onClick={() => setDrawerState({ isVisible: true, id: null })}
    >{t('Add new transponder ID')}</LayoutEl.PageHeaderActionButton>
  }

  function renderEditCreateState() {
    return <CreateEditTransponderId
      isVisible={drawer.isVisible}
      idTransponderId={drawer.id}
      farmerId={farmerId}
      fetchData={fetchData}
      handleHiddenDrawer={() => setDrawerState({ isVisible: false, id: null })}
    />
  }

  function renderDeleteModal() {
    return <Dialog
      key='dialog-transponder-id-delete'
      textHeader={t('Delete transponder ID: {{uniqueId}}', { uniqueId: selectedItem?.uniqueId })}
      textClose={t('Close')}
      textContent={t('Are you sure that you want to delete transponder ID {{uniqueId}}?', { uniqueId: selectedItem?.uniqueId })}
      textSubmit={t('Delete transponder ID')}
      handleClose={() => setSelectedItem(null)}
      handleSubmit={onTransponderIdDelete}
      type='abort'
      isDialogOpen={Boolean(selectedItem)}
      isLoading={isDeleteLoading}
    />
  }

  return <Layout
    title={''}
    isBusy={isBusyData}
    childContainerSize={'auto'}
    fontSizeHeader={'18px'}
    actions={displayAction && renderActions()}
    useSpinner
  >
    {selectedItem && renderDeleteModal()}
    {renderEditCreateState()}
    {transponderIds && renderTable()}
  </Layout>
}
export default TransponderId
